// removed by extract-text-webpack-plugin
module.exports = {"introduction__motion":"_2TOCo0CE09qn_ql2GxjYjE","introduction__motion__wrapper":"_39N-_0ODBGzLpqxT-6A6RC","title":"nIKvud5TuUORhqb17--hN","subtitle":"_2svdqDrVUK5gaHkWJIj09C","logo_svg":"_3vxqZ8egHwWjMlC1TMQq4Z","circle_wrapper":"_15SIm99A83gcMH0mBrxpf3","type_wrapper":"_3xE3T59t3zLcRxTKbidLwA","background_svg":"o8Ko5lDRR10fFd1HuipB_","letter_svg":"_30XGIZ3lc37x4H0jnaAA8Q","mouth_svg":"_25cPcDXz67a08IsEZZxfGN","eyes_svg":"_115BTlKpEaXuikp_Nu3jQb","smile_svg":"_1O7sLv_erp0M1tALIOzCMa"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/IntroMotion/IntroMotion.module.css
 ** module id = 231
 ** module chunks = 0
 **/